var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["go-list-item"],
      attrs: { "data-template": "agent-cards", "data-size": "2x1" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          class: [
            "go-card-main",
            { "border-active": _vm.isCheckedDelete },
            { disableTag: _vm.isEditMode },
          ],
        },
        [
          _c("div", { staticClass: "go-card-header" }, [
            _c("div", { staticClass: "go-block-header" }, [
              _c(
                "a",
                {
                  staticClass: "go-card-title",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.select.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.formModel.briefingPageName) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-block-body" }, [
              _vm.formModel.briefingDescription
                ? _c("div", { staticClass: "go-card-desc" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.formModel.briefingDescription) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          (_vm.formModel.listDocumentFeatured &&
            _vm.formModel.listDocumentFeatured.length > 0) ||
          _vm.formModel.briefingDescription
            ? _c("div", { staticClass: "go-card-body" }, [
                _c("div", { staticClass: "go-block-body" }, [
                  _c(
                    "div",
                    { staticClass: "go-row" },
                    _vm._l(
                      _vm.filteredAndSortedItems(
                        _vm.formModel.listDocumentFeatured
                          ? _vm.formModel.listDocumentFeatured.slice(0, 2)
                          : []
                      ),
                      function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.parentDocDetail._id + index,
                            staticClass: "go-col",
                          },
                          [
                            _c("ul", { staticClass: "go-card-sub-list" }, [
                              _c("li", { staticClass: "go-list-item" }, [
                                _c("div", { staticClass: "go-card-sub" }, [
                                  _c("div", { staticClass: "go-card-label" }, [
                                    _c("em", { staticClass: "go-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(_vm.makeReportTypeText(item))
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "go-card-img",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.onHandleOpenModal(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: item.parentDocDetail
                                            .image_uri_thumbnail,
                                        },
                                        on: { error: _vm.onImageError },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "go-card-body" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "go-card-title",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.onHandleOpenModal(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.parentDocDetail.title) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "go-card-footer" },
            [
              _vm.formModel.bpType === "MY_BRIEFING"
                ? [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c(
                        "div",
                        { staticClass: "custom-control custom-switch" },
                        [
                          _c("input", {
                            staticClass: "custom-control-input",
                            attrs: { type: "checkbox", id: _vm.idSwitch },
                            domProps: { checked: _vm.formModel.isActive },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openConfirm()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "custom-control-label",
                            attrs: { for: _vm.idSwitch },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "go-info-item go-tooltip-area",
                          attrs: {
                            "data-toggle": "tooltip",
                            title:
                              _vm.formModel.privacy === "PRIVATE"
                                ? _vm.$t("scrap-agent.private")
                                : _vm.$t("scrap-agent.public"),
                          },
                        },
                        [
                          _c("i", {
                            class: [
                              "go-icon-18",
                              {
                                "go-icon-private":
                                  _vm.formModel.privacy === "PRIVATE",
                              },
                              {
                                "go-icon-public":
                                  _vm.formModel.privacy === "PUBLIC",
                              },
                            ],
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-info-item go-datetime" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my-create.common.label.last-update")) +
                            " " +
                            _vm._s(
                              _vm.formatDateAgo(
                                _vm.moment(_vm.formModel.modifyDate)
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-block-footer" }, [
                      _c("span", { staticClass: "go-info-item go-count" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formModel.subscribeCount)),
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("briefing.label.subscribers")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: [
                            "btn go-btn-icon",
                            { active: !!_vm.formModel.isPinned || false },
                          ],
                          attrs: {
                            type: "button",
                            "data-toggle": "button",
                            disabled: _vm.getIsPinned,
                            "aria-pressed": _vm.formModel.isPinned
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handlePinBriefing(
                                _vm.formModel.bpId,
                                !_vm.formModel.isPinned,
                                _vm.formModel
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: { customClass: "go-tooltip" },
                                  expression: "{ customClass: 'go-tooltip' }",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "go-tooltip-area go-toggle-off",
                              attrs: {
                                "data-toggle": "tooltip",
                                title: _vm.$t("briefing.label.pin.fav-on"),
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-16 go-icon-star",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: { customClass: "go-tooltip" },
                                  expression: "{ customClass: 'go-tooltip' }",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "go-tooltip-area go-toggle-on",
                              attrs: {
                                "data-toggle": "tooltip",
                                title: _vm.$t("briefing.label.pin.fav-off"),
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "go-icon-16 go-icon-star-on",
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                : _vm.formModel.bpType === "SOCIAL_BRIEFING" ||
                  _vm.formModel.bpType === "BRIEFING_PAGE"
                ? [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c(
                        "a",
                        {
                          staticClass: "go-info-item go-user-info",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.selectUserSocial(
                                _vm.formModel.userProfile.userKey
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "go-user-thumb" }, [
                            _c("img", {
                              attrs: {
                                src: _vm.formModel.userProfile.imageUrl,
                              },
                              on: { error: _vm.onErrorImageAvatar },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-user-id" }, [
                            _vm._v(_vm._s(_vm.truncatedUserName)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-info-item go-datetime" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my-create.common.label.last-update")) +
                            " " +
                            _vm._s(
                              _vm.formatDateAgo(
                                _vm.moment(_vm.formModel.modifyDate)
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-block-footer" }, [
                      _c("span", { staticClass: "go-info-item go-count" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formModel.subscribeCount)),
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("briefing.label.subscribers")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: [
                            "btn go-btn-subscribe round",
                            {
                              active:
                                _vm.formModel.subscribeStatus === "SUBSCRIBE",
                            },
                          ],
                          attrs: {
                            type: "button",
                            "data-toggle": "button",
                            "aria-pressed": "false",
                            disabled: _vm.formModel.updatingSubscribe,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleSubscribe.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "go-toggle-off" }, [
                            _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("briefing.details.label.subscribe")
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "go-toggle-on" }, [
                            _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("briefing.details.label.subscribed")
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.formModel.bpType === "RECOMMENDATION_BRIEFING"
                ? [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c(
                        "div",
                        { staticClass: "go-info-item go-user-info goover" },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "go-user-id",
                              staticStyle: { "font-size": "12px" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("briefing.details.label.suggested")
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-info-item go-datetime" }, [
                        _vm._v(
                          _vm._s(_vm.$t("my-create.common.label.last-update")) +
                            " " +
                            _vm._s(
                              _vm.formatDateAgo(
                                _vm.moment(_vm.formModel.modifyDate)
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-block-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default round",
                          attrs: {
                            type: "button",
                            disabled: _vm.formModel.updatingSubscribe,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleSubscribe.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "briefing.details.label.AddAsMyBriefingAgent"
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : _vm.formModel.bpType === "COMPANY_BRIEFING_PAGE"
                ? [
                    _c("div", { staticClass: "go-block-body" }, [
                      _c("div", { staticClass: "go-emotion" }, [
                        _c("div", { staticClass: "go-list-item" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("companyCard.label.market"))),
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-list-item" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("companyCard.label.news"))),
                          ]),
                          _vm._v(" "),
                          _vm._m(2),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-list-item" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("companyCard.label.social"))),
                          ]),
                          _vm._v(" "),
                          _vm._m(3),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-block-footer" }, [
                      _c("span", { staticClass: "go-info-item go-count" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formModel.subscribeCount)),
                        ]),
                        _vm._v(
                          _vm._s(_vm.$t("briefing.label.subscribers")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: [
                            "btn go-btn-subscribe round",
                            {
                              active:
                                _vm.formModel.subscribeStatus === "SUBSCRIBE",
                            },
                          ],
                          attrs: {
                            type: "button",
                            "data-toggle": "button",
                            "aria-pressed": "false",
                            disabled: _vm.formModel.updatingSubscribe,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleSubscribe.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._m(4), _vm._v(" "), _vm._m(5)]
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.getIsShowDeleteBriefing
            ? _c("popupDeleteBriefingComponent", {
                on: {
                  handleDeleteSingleBriefing: _vm.handleDeleteBriefingPage,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("confirm-action", {
        attrs: {
          "open-modal": _vm.isOpenConfirmAction,
          state: _vm.formModel.isActive,
          bfName: _vm.formModel.briefingPageName,
          "is-loading": _vm.isLoadingCheckActive,
        },
        on: {
          no: function ($event) {
            _vm.isOpenConfirmAction = false
          },
          yes: function ($event) {
            return _vm.checkActiveBf()
          },
        },
      }),
      _vm._v(" "),
      _c("out-of-active", {
        attrs: { "open-modal": _vm.isOutOfActive, "feature-idx": 7 },
        on: {
          no: function ($event) {
            _vm.isOutOfActive = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-user-featured" }, [
      _c("i", { staticClass: "go-icon-16 go-icon-goover-full" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "go-icon-area go-tooltip-area",
        attrs: { "data-toggle": "tooltip", "data-original-title": "Positive" },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-emotion-positive" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "go-icon-area go-tooltip-area",
        attrs: { "data-toggle": "tooltip", title: "Neutral" },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-emotion-neutral" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "go-icon-area go-tooltip-area",
        attrs: { "data-toggle": "tooltip", title: "Negative" },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-emotion-negative" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-toggle-off" }, [
      _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
      _c("em", [_vm._v("Subscribe")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-toggle-on" }, [
      _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
      _c("em", [_vm._v("Subscribed")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }